import { render, staticRenderFns } from "./ResidenceMedicationManagement.vue?vue&type=template&id=1de05555&scoped=true&"
import script from "./ResidenceMedicationManagement.vue?vue&type=script&lang=js&"
export * from "./ResidenceMedicationManagement.vue?vue&type=script&lang=js&"
import style0 from "./ResidenceMedicationManagement.vue?vue&type=style&index=0&id=1de05555&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de05555",
  null
  
)

export default component.exports